var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReactLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke: #a9a9a9;\n      }\n\n      .st1 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n\n      .st3 {\n        fill: #a9a9a9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 11.5,
    cy: 10.3,
    r: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 11.5,
    cy: 10.3,
    rx: 11,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 11.5,
    cy: 10.3,
    rx: 4.2,
    ry: 11,
    transform: "translate(-3.6 7.1) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 11.6,
    cy: 10.3,
    rx: 11,
    ry: 4.2,
    transform: "translate(-3.1 15.2) rotate(-60)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReactLogo);
export default __webpack_public_path__ + "static/media/icon-react-logo.d41257b5ea4c384cd443f6b4e8667c4d.svg";
export { ForwardRef as ReactComponent };